"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ProductPrice = function (_a) {
    var price = _a.price;
    return (react_1.default.createElement(Container, null,
        price.basePrice !== price.currentPrice && (react_1.default.createElement(BasePrice, null,
            price.basePrice,
            " ",
            react_1.default.createElement(Currency, null))),
        react_1.default.createElement(CurrentPrice, null,
            react_1.default.createElement("span", null, price.currentPrice),
            " ",
            react_1.default.createElement(Currency, null))));
};
var Currency = function () {
    return (react_1.default.createElement(Abbr, { className: "currency", title: "RUB" }, "\u0420\u0443\u0431"));
};
var Abbr = styled_components_1.default.abbr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: rubfont;\n"], ["\n  font-family: rubfont;\n"])));
var Container = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n  margin-top: 16px;\n"], ["\n  text-align: center;\n  margin-top: 16px;\n"])));
var CurrentPrice = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: #2a3133;\n  font-size: 24px;\n  line-height: 32px;\n  font-weight: 500;\n"], ["\n  color: #2a3133;\n  font-size: 24px;\n  line-height: 32px;\n  font-weight: 500;\n"])));
var BasePrice = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: #949899;\n  font-size: 13px;\n  line-height: 20px;\n  font-weight: 400;\n  text-decoration: line-through;\n  margin-right: 10px;\n"], ["\n  color: #949899;\n  font-size: 13px;\n  line-height: 20px;\n  font-weight: 400;\n  text-decoration: line-through;\n  margin-right: 10px;\n"])));
exports.default = ProductPrice;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
